import { FC, useMemo } from 'react'
import { Flex, Text } from '@chakra-ui/react'

type Props = {
  text: string
  status: IElementStatus
  onClick?: () => void
}

export enum IElementStatus {
  DEFAULT = 'DEFAULT',
  SELECTED = 'SELECTED',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED'
}

const MatchingElement: FC<Props> = ({ text, status, onClick }) => {
  const bgColor = useMemo(() => {
    switch (status) {
      case IElementStatus.SELECTED:
        return 'wood.100'
      case IElementStatus.SUCCESS:
        return 'green.50'
      case IElementStatus.FAILED:
        return 'red.50'
      case IElementStatus.DEFAULT:
        return 'transparent'
    }
  }, [status])

  const color = useMemo(() => {
    switch (status) {
      case IElementStatus.SELECTED:
        return 'wood.800'
      case IElementStatus.SUCCESS:
        return 'green.800'
      case IElementStatus.FAILED:
        return 'red.700'
      case IElementStatus.DEFAULT:
        return 'black.950'
    }
  }, [status])

  const borderColor = useMemo(() => {
    switch (status) {
      case IElementStatus.SELECTED:
        return 'wood.800'
      case IElementStatus.SUCCESS:
        return 'green.800'
      case IElementStatus.FAILED:
        return 'red.700'
      case IElementStatus.DEFAULT:
        return 'black.200'
    }
  }, [status])

  return (
    <Flex
      borderColor={borderColor}
      bg={bgColor}
      borderWidth={1}
      w='full'
      align={'center'}
      justify={'center'}
      minH={8}
      rounded={'xs'}
      _hover={{ cursor: onClick ? 'pointer' : 'default' }}
      onClick={onClick}
    >
      <Text align={'center'} textStyle={'small'} color={color}>
        {text}
      </Text>
    </Flex>
  )
}

export default MatchingElement
